// Typewriter engine, shared by the main chat reveal (ChatRenderer) and the A/B
// comparison panes (AbTestPane). The reply is split on Markdown structures
// (lists, fenced/inline code, bold, italic, strikethrough, links); a split that
// IS such a structure renders whole (instant), and the plain text between is
// typed character by character. Mirrors the desktop typewriter_feature.py.

const TYPEWRITER_PATTERN = new RegExp(
  "((?:^\\s*(?:[-*+]|\\d+\\.)\\s+.*\\n?)+)" +
    "|(\\x60{3}.*?\\x60{3}|\\*\\*.*?\\*\\*|\\*.*?\\*|__.*?__| _.*?_ |~~.*?~~|\\x60.*?\\x60|\\[.*?\\]\\(.*?\\))",
  "m",
);

export function segmentForTypewriter(reply: string): string[] {
  return reply.split(TYPEWRITER_PATTERN).filter(Boolean);
}

export function isMarkdownSegment(segment: string): boolean {
  // Mirror desktop re.match: does the pattern match at the start of the segment?
  const m = TYPEWRITER_PATTERN.exec(segment);
  return m !== null && m.index === 0;
}

// Type a reply out segment by segment into `setText`, one tick per `speedMs`.
// A Markdown structure appears whole; plain text is typed one character per
// tick. `registerTimer` receives the pending timeout id after each tick (and
// null when finished) so the caller can clear it on unmount. Resolves when the
// whole reply has been typed.
export function runTypewriter(
  reply: string,
  speedMs: number,
  setText: (t: string) => void,
  registerTimer: (id: number | null) => void,
): Promise<void> {
  return new Promise<void>((resolve) => {
    const segments = segmentForTypewriter(reply);
    let segIdx = 0;
    let charIdx = 0;
    let buf = "";
    setText(""); // show the (empty) bubble, hiding any indicator
    const tick = () => {
      if (segIdx >= segments.length) {
        registerTimer(null);
        resolve();
        return;
      }
      const seg = segments[segIdx];
      let changed = false;
      if (isMarkdownSegment(seg)) {
        buf += seg;
        segIdx += 1;
        charIdx = 0;
        changed = true;
      } else if (charIdx < seg.length) {
        buf += seg[charIdx];
        charIdx += 1;
        changed = true;
      } else {
        segIdx += 1;
        charIdx = 0;
      }
      if (changed) setText(buf);
      registerTimer(window.setTimeout(tick, speedMs));
    };
    registerTimer(window.setTimeout(tick, speedMs));
  });
}
